import type { ReactNode } from 'react';

import s from './ExternalLinkButton.module.css';

type ExternalLinkButtonProps = {
  href: string;
  label: string;
  icon?: ReactNode;
  ariaLabel?: string;
};

function ExternalLinkButton({ href, label, icon, ariaLabel }: ExternalLinkButtonProps) {
  return (
    <a
      href={href}
      className={s.link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}>
      <span className={s.inner}>
        <span className={s.text}>{label}</span>
        {icon && (
          <span className={s.glyph} aria-hidden>
            {icon}
          </span>
        )}
      </span>
    </a>
  );
}

export default ExternalLinkButton;
